export const site = {
  name: 'AMIRA Beauty',
  url: 'https://www.amirabeauty.nl',
  locale: 'nl_NL',
  defaultTitle: 'AMIRA Beauty | Pure Marokkaanse verzorging online',
  defaultDescription:
    'Shop pure Marokkaanse verzorging: arganolie, Savon Beldi, ghassoul, rozenwater en de complete Hammam Ritueel Set. Vóór 22:00 besteld, morgen in huis. Gratis verzending vanaf € 50.',
  livingName: 'AMIRA Living',
  livingTitle: 'AMIRA Living | Marokkaanse sieraden, servies & theeglazen',
  livingDescription:
    'Handgemaakt uit Marokko: Berber zilveren sieraden, beschilderd Safi-servies, beldi theeglazen, theepotten en lantaarns. Vóór 22:00 besteld, morgen in huis.',
}
